import React, { Component } from 'react';
import { NormalButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import Stopwatch from '../Stopwatch/Stopwatch';
import moment from 'moment';
import { screwSwitch } from '../../stores/batch/device-switches/screw-switch';

@inject('batchStore')
@observer
class Screw extends Component {
  render() {
    const { device, batchStore } = this.props;
    const { active, startTime } = batchStore.getDeviceStatus(device.id);
    let diff = 0;
    if (startTime) {
      const endTime = moment();
      diff = Math.round(endTime.diff(startTime) / 1000);
    }
    const isOnSwitchOn = batchStore.isOutputOn(device.switchOnePNo);
    const isOffSwitchOn = batchStore.isOutputOn(device.switchOffPNo);
    const isActive = isOnSwitchOn ? 'active' : '';
    const isOn = !!isActive || !!active;
    const btnClassOn = isOnSwitchOn ? 'active' : '';
    const btnClassOff = isOffSwitchOn ? 'active' : '';

    return (
      <div id={`device-${device.id}`} className={`${isActive} device-gui device-gui--screw device-icon-${device.icon}`}>
        <div className="device-icon body"/>
        <div className="device-icon drill-wrap">
          <div className="device-icon drill"/>
        </div>
        <div className="device-icon motor"/>
        <div className="device-gui__row">
          {device.switchOnePNo  && !device.switchOffPNo && (
            <NormalButton className={`btn-batch ${btnClassOn}`}
              onClick={() => screwSwitch(batchStore.rootStore, device.id, !isOn)}>
              <i className="fa fa-power-off"/>
            </NormalButton>
          )}
          {device.switchOnePNo && device.switchOffPNo && (
            <div>
              <NormalButton className={`btn-batch ${btnClassOn}`}
                onClick={() => {
                  screwSwitch(batchStore.rootStore, device.id, true);
                }}>
                <i className="fa fa-power-off"/>
              </NormalButton>
              <NormalButton className={`btn-batch btn-batch-red ${btnClassOff}`}
                onClick={() => screwSwitch(batchStore.rootStore, device.id, false)}>
                <i className="fa fa-power-off"/>
              </NormalButton>
            </div>
          )}
        </div>
        <div className="device-label device-label--horizontal">
          <div className="device-type" title={`#${device.id}`}>{device.description || `#${device.id}`}</div>
          <div className="status status-counter"><Stopwatch start={isOn} startTime={diff} stop={!isOn} delay={device.onDelay}/></div>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Screw);
